module.exports = __webpack_public_path__ + "img/e8e357d.jpg";